import React from 'react';
import { Appointments } from '@devexpress/dx-react-scheduler';
import { draftWorkScheduleId } from 'components/AddWorkSchedule/WorkScheduleCalendar/context/WorkScheduleCalendarProvider';
import DraftAppointment from './DraftAppointment';
import Appointment from './Appointment';

export default function AppointmentContentComponent({
  data,
  durationType,
}: Appointments.AppointmentContentProps) {
  const isDraftSchedule = data.id === draftWorkScheduleId;
  return (
    <>
      {isDraftSchedule ? (
        <DraftAppointment data={data} durationType={durationType} />
      ) : (
        <Appointment data={data} durationType={durationType} />
      )}
    </>
  );
}
